const Brand = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="92"
      height="24"
      viewBox="0 0 92 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 23.5122V0.486328H8.21033C14.7393 0.486328 19.5225 4.74134 19.5225 12.015C19.5225 19.2887 14.7063 23.5122 8.1773 23.5122H0ZM8.01544 19.3551C11.7647 19.3551 14.8995 17.0168 14.8995 12.015C14.8995 7.01323 11.7961 4.64343 8.04682 4.64343H4.4611V19.3551H8.01544Z"
        fill="#6913D8"
      />
      <path
        d="M36.8367 18.9333C36.029 21.6931 33.507 23.9999 29.5975 23.9999C25.2339 23.9999 21.3872 20.8501 21.3872 15.4583C21.3872 10.3603 25.1364 7.04785 29.2094 7.04785C34.1231 7.04785 37.063 10.1976 37.063 15.3289C37.063 15.9462 36.9986 16.5951 36.9986 16.6598H25.622C25.7195 18.7707 27.4966 20.2975 29.6306 20.2975C31.634 20.2975 32.734 19.2901 33.251 17.8613L36.8367 18.9333ZM32.8282 13.7042C32.7637 12.1127 31.7298 10.5544 29.2722 10.5544C27.0424 10.5544 25.8136 12.2438 25.7162 13.7042H32.8282Z"
        fill="#6913D8"
      />
      <path
        d="M43.5784 14.3216L47.4895 13.7374C48.3946 13.608 48.6853 13.1533 48.6853 12.6007C48.6853 11.4639 47.8133 10.5229 46.0031 10.5229C44.1284 10.5229 43.0945 11.7244 42.964 13.1217L39.1504 12.3102C39.4097 9.80934 41.7038 7.04956 45.97 7.04956C51.0125 7.04956 52.8871 9.90726 52.8871 13.1217V20.9812C52.8871 21.8259 52.9846 22.9627 53.0804 23.5137H49.1379C49.0404 23.0922 48.976 22.2143 48.976 21.5969C48.1684 22.8631 46.6489 23.9684 44.2887 23.9684C40.8945 23.9684 38.8267 21.6633 38.8267 19.1624C38.8267 16.3031 40.9276 14.7116 43.5784 14.3216ZM48.6853 17.0498V16.3362L45.098 16.8889C43.9996 17.0515 43.1259 17.6688 43.1259 18.9019C43.1259 19.8428 43.8047 20.7522 45.1938 20.7522C47.004 20.7522 48.6853 19.8743 48.6853 17.0498Z"
        fill="#6913D8"
      />
      <path d="M56.3923 23.5121V0H60.6916V23.5121H56.3923Z" fill="#6913D8" />
      <path d="M64.3271 23.5121V0H68.6264V23.5121H64.3271Z" fill="#6913D8" />
      <path
        d="M74.8709 18.2515C74.9683 19.5177 75.9048 20.6877 77.7794 20.6877C79.2015 20.6877 79.8803 19.9409 79.8803 19.0962C79.8803 18.3809 79.3947 17.7968 78.1675 17.5379L76.0666 17.05C72.9962 16.3679 71.6056 14.5176 71.6056 12.2755C71.6056 9.41784 74.126 7.04639 77.5531 7.04639C82.0786 7.04639 83.5965 9.93727 83.7914 11.6582L80.204 12.4697C80.0752 11.5288 79.3964 10.3256 77.5862 10.3256C76.4548 10.3256 75.5497 11.0077 75.5497 11.9171C75.5497 12.6971 76.1311 13.1833 77.0048 13.3459L79.2675 13.8338C82.4024 14.4827 83.9863 16.3994 83.9863 18.7377C83.9863 21.3365 81.9828 23.9984 77.8124 23.9984C73.0293 23.9984 71.3809 20.8802 71.186 19.0613L74.8709 18.2515Z"
        fill="#6913D8"
      />
      <path
        d="M90.9656 16.4974H87.8308L86.7952 0.486328H91.9995L90.9656 16.4974ZM89.3816 18.6083C90.8037 18.6083 91.9665 19.7766 91.9665 21.2071C91.9665 22.6376 90.8037 23.7727 89.3816 23.7727C87.991 23.7727 86.8612 22.636 86.8612 21.2071C86.8612 19.7783 87.991 18.6083 89.3816 18.6083Z"
        fill="#FFE156"
      />
    </svg>
  );
};

const BrandSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.6094 21.0993H0.25827V0.5H7.63862C10.6408 0.5 13.086 1.42026 14.9742 3.26079C16.8624 5.10132 17.8067 7.61946 17.8071 10.8152C17.8071 13.9927 16.8578 16.5013 14.9593 18.341C13.0607 20.1807 10.6108 21.1002 7.6094 21.0993ZM4.26798 17.3799H7.46393C9.2655 17.3799 10.7475 16.8182 11.91 15.6946C13.0725 14.5711 13.6528 12.9438 13.6507 10.8127C13.6507 8.6825 13.0705 7.05044 11.91 5.91653C10.7496 4.78262 9.27731 4.21608 7.49315 4.21691H4.26798V17.3799Z"
        fill="#6913D8"
      />
      <path
        d="M25.7417 0.499939L24.8092 14.8255H21.9906L21.0581 0.499939H25.7417ZM21.7898 20.666C21.5731 20.4547 21.4021 20.2013 21.2871 19.9214C21.1722 19.6415 21.1158 19.341 21.1215 19.0385C21.1167 18.7339 21.1734 18.4315 21.2883 18.1494C21.4031 17.8673 21.5737 17.6113 21.7898 17.3967C21.9942 17.1781 22.2419 17.0044 22.517 16.8867C22.7922 16.769 23.0888 16.7098 23.3881 16.7128C24.004 16.7145 24.5943 16.9599 25.0299 17.3954C25.4654 17.831 25.7108 18.4213 25.7125 19.0372C25.7175 19.3411 25.6593 19.6427 25.5416 19.9228C25.4239 20.203 25.2492 20.4556 25.0286 20.6647C24.8139 20.8807 24.5579 21.0512 24.2758 21.1661C23.9937 21.2809 23.6914 21.3377 23.3868 21.333C23.0894 21.3361 22.7944 21.2782 22.5201 21.1631C22.2457 21.0479 21.9979 20.8779 21.7917 20.6635L21.7898 20.666Z"
        fill="#FEE156"
      />
    </svg>
  );
};

export { Brand, BrandSmall };
